import { createSlice } from "@reduxjs/toolkit";

const eomSlice = createSlice({
  name: "eom",
  initialState: {
    selectedRow: {},
    year: "",
    month: "",
    screen: "",
  },
  reducers: {
    updateSelectedRow: (state, action) => {
      state.selectedRow = action.payload;
    },
    clearSelectedRow: (state, action) => {
      state.selectedRow = {};
    },
    updateEomData: (state, action) => {
      state.year = action.payload.year;
      state.month = action.payload.month;
      state.screen = action.payload.screen;
    },
    clearData: (state, action) => {
      state.year = "";
      state.month = "";
      state.screen = "";
    },
  },
});

export const selectRow = (state) => {
  return state?.eom;
};

export const getData = (state) => {
  return {
    fscreen: state?.eom?.screen,
    fyear: state?.eom?.year,
    fmonth: state?.eom?.month,
  };
};

export const { updateSelectedRow, clearSelectedRow, updateEomData, clearData } =
  eomSlice.actions;

export default eomSlice.reducer;
